import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanDeactivate, Router } from '@angular/router';
import { TestServiceComponent } from './test-service.component';
import { Observable} from 'rxjs';


@Injectable({
    providedIn: 'root',
})
export class TestServiceGuard implements CanDeactivate<TestServiceComponent> {

    constructor() {}

    canDeactivate(component: TestServiceComponent,
        currentRoute: ActivatedRouteSnapshot,
        currentState: RouterStateSnapshot,
        nextState: RouterStateSnapshot): Observable<boolean> | boolean  {
        if(!component.opened) {
            component.openDialog();
        }

        return true;
    }
}
